import styled from "styled-components";
// import { ASSETS } from "../../utils/config";

export const ModalContainer = styled.div`
  min-width: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40vw;
  height: 60vh;
  box-shadow: 24px 24px 48px rgba(0, 0, 0, 0.2);
  border-radius: 14px;
  background-color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative; /* Relative position to use as a reference for children */
  padding: 40px;
  /* Adjust the height based on the screen height */
  // @media (max-height: 750px) {
  //   height: 55vh;
  // }
`;

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 10px;
  margin-top: 20px;
  gap: 10px; /* Add vertical space between direct children */
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  .close-icon {
    cursor: pointer;
    color: #757575;
    transition: color 0.2s;

    &:hover {
      color: #000;
    }
  }
`;

export const PointerList = styled.ul`
  list-style-type: none; /* Remove default list styling */
  padding-left: 20px;
  margin-top: 10px;
`;

export const PointerItem = styled.li`
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px; /* Space for the dot */

  &::before {
    content: "•"; /* Add dot using pseudo-element */
    position: absolute;
    left: 0;
    top: 50%; /* Center the dot vertically */
    transform: translateY(-50%); /* Adjust for perfect vertical centering */
    color: #000; /* Dot color */
    font-size: 1.8em; /* Increase font size to make the dot bigger */
    line-height: 1; /* Ensure the dot doesn't affect line height */
  }
`;
